<template>
    <div class="dx-widget">
        <div class="dx-datagrid-pager dx-pager">
            <div class="dx-page-sizes" :key="index" v-for="(size, index) in pageSizes" style="display: flex; align-items: center;">
                <div class="dx-page-size" role="button" :class="{ 'dx-selection': size === currentPageSize }" @click="changePageSize(size)">{{ size }}</div>
            </div>
            <div class="dx-pages" style="display: flex; align-items: center;">
                <div class="dx-info">Page {{ currentPage }} of {{ totalPages }} ({{ totalItems }} items)</div>
                <div class="dx-navigate-button" role="button" :class="{ 'dx-button-disable': currentPage === 1 }" aria-label="Page 1" tabindex="0" @click="currentPage === 1 ? {} : changePage(1)"><i class="dx-icon-chevrondoubleleft"></i></div>
                <div class="dx-navigate-button dx-prev-button" :class="{ 'dx-button-disable': currentPage === 1 }" role="button" aria-label="Previous page" tabindex="0" @click="currentPage === 1 ? {} : changePage(currentPage - 1)"></div>
                <div :key="index" v-for="(page, index) in pageStrip" class="dx-page" :class="{ 'dx-selection': page === currentPage }" role="button" :aria-label="'Page ' + page" tabindex="0" @click="changePage(page)">{{ page }}</div>
                <div class="dx-navigate-button dx-next-button" :class="{ 'dx-button-disable': currentPage === totalPages }" role="button" aria-label=" Next page" tabindex="0" @click="currentPage === totalPages ? {} : changePage(currentPage + 1)"></div>
                <div class="dx-navigate-button" role="button" :class="{ 'dx-button-disable': currentPage === totalPages }" :aria-label="'Page ' + totalPages" tabindex="0" @click="currentPage === totalPages ? {} : changePage(totalPages)"><i class="dx-icon-chevrondoubleright"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PaginationComponent',
    props: {
        totalPages: {
            type: Number,
            default: 1,
        },
        totalItems: {
            type: Number,
            default: 1,
        },
        pageSizes: {
            type: Array,
            default: () => [10, 25, 50, 100, 500],
        },
        pageSize: {
            type: Number,
            default: 50
        },
        page: {
            type: Number,
            default: 1
        }
    },
    created() {
        this.$emit('on-page-change', { page: 1, pageSize: 50 });
    },
    data() {
        return {
            currentPage: this.page || 1,
            currentPageSize: this.pageSize || 50
        };
    },
    computed: {
        pageStrip() {
            const start = Math.max(1, Math.min(this.currentPage - 2, this.totalPages));
            const end = Math.max(1, Math.min(this.currentPage + 2, this.totalPages));

            if (start === end && start === 1)
                return [1];

            return Array(end - start + 1).fill().map((_, idx) => start + idx);
        },
    },
    methods: {
        changePage(newPage) {
            this.currentPage = newPage;
            this.$emit('on-page-change', { page: newPage, pageSize: this.currentPageSize });
        },
        changePageSize(newPageSize) {
            this.currentPageSize = newPageSize;
            this.changePage(1);
        },
        refreshPage() {
            this.$emit('on-page-change', { page: this.currentPage, pageSize: this.currentPageSize });
        },
        reset(movePageSizeToFirstPositionToo) {
            if (movePageSizeToFirstPositionToo) {
                this.changePageSize(this.pageSizes[2] || 50);
            } else {
                this.changePage(1);
            }
        }
    },
    watch: {
        page(newPage) {
            if (newPage !== this.currentPage) {
                this.currentPage = newPage;
            }
        },
        pageSize(newSize) {
            if (newSize && newSize !== this.currentPageSize) {
                this.currentPageSize = newSize;
            }
        }
    }
};
</script>
<style>
 .dx-icon-chevrondoubleleft {font-size: 21px}
 .dx-icon-chevrondoubleright {font-size: 21px}
</style>